import React from 'react';
import styled from 'styled-components';
import { navy } from '@zocdoc/branding/colors';

import { Icon } from './_base';

const InsuranceSVG = styled(Icon).attrs({ viewBox: '0 0 63 40' })`
    width: 1.575em;
`;

const Insurance = ({ color = navy, ...props }) => (
    <InsuranceSVG
        data-test="icon-insurance"
        {...props}
    >
        <path
            d="M63,40H0V0H63V40ZM5.52,34.48h52v-29h-52v29Zm46.09-6H22.88V23H51.62v5.52Zm-34.48,0H11.38V23h5.75v5.52ZM51.62,17H22.88V11.49H51.62V17ZM17.13,17H11.38V11.49h5.75V17Z"
            fill={color}
        />
    </InsuranceSVG>
);

export {
    Insurance as default,
    Insurance,
};
